import React, { useState } from 'react';
import { SignIn as AmplifySignIn } from 'aws-amplify-react';
import { Route, Redirect } from 'react-router-dom';

import Ghosting from './Ghosting';
import { useUser } from '..';
import { useQueryString } from '../hooks/useQueryString';
import { getReturnPath } from '../returnPath';
import TrueImpactServiceBanner from '../../design-system/components/TrueImpactServiceBanner';

const notIncludedPaths = [
  '/',
  '/login',
  '/signup',
  '/signup/donor',
  '/signup/npo',
  '/forgot',
];

const getReturnRoute = () => {
  const pathname = window.location.pathname;
  // Preserve the query string (e.g. claim ?token=) so it survives login/registration.
  const path = notIncludedPaths.includes(pathname)
    ? null
    : `${pathname}${window.location.search}`;
  if (path) return path;
  const result = getReturnPath();
  // if (result) {
  //   deleteReturnPath();
  // }
  return result;
};

export default class SignIn extends AmplifySignIn {
  handleSignedIn = () => {
    this.changeState('signedIn');
  };

  showComponent() {
    return <_SignIn onSignedIn={this.handleSignedIn} />;
  }
}

const getLoginUrl = (email, returnPath) => {
  const params = new URLSearchParams();
  email && params.set('email', email);
  returnPath && params.set('r', returnPath);
  const queryString = params.toString();
  return queryString ? `/login?${queryString}` : '/login';
};

function _SignIn({ onSignedIn }) {
  const user = useUser();
  const query = useQueryString();
  const [email] = useState(
    decodeURIComponent(
      (query.get('email') || query.get('username') || '').replace(/ /g, '+'),
    ),
  );
  const [returnPath] = useState(query.get('r') || getReturnRoute());

  return (
    <>
      <TrueImpactServiceBanner />
      <Route path="/login">
        <Ghosting
          onSignedIn={onSignedIn}
          selectedEmail={email}
          returnPath={returnPath}
        />
      </Route>
      {!user.password && (
        <Route path="/">
          <Redirect to={getLoginUrl(email, returnPath)} />
        </Route>
      )}
    </>
  );
}
